module.exports = "/images/merchant-placeholder-avatar.jpg";